export class SuperSearch {
    filter: string = ""
}

export class SearchResult {
    pos: number = 0;
    type: string = "";
    link: string = "";
    content: string = "";
    lastModified: Date | string = "";
}